import toggle from 'components/common/hoc/toggle'
import { compose, withHandlers } from 'recompose'
import { TogglablePreview, ExpandedPreview } from './TogglePreview'

const withToggleHandlers = withHandlers({
  toggleOnClick: ({ toggleHandlers: { onClick } = {}}) => e => {
    if (e.target && e.target.attributes['data-toggle-link']) {
      e.preventDefault()
      onClick(e)
    }
  }
})

export default compose(
  toggle,
  withToggleHandlers
)(TogglablePreview)

export { ExpandedPreview }
